import { combineReducers } from 'redux';
import authReducer from './_slice/authReducer';
import userReducer from './_slice/userReducer';
import contractReducer from './_slice/contractReducer';
import notificationReducer from './_slice/notificationReducer';
import commissionReducer from './_slice/commissionReducer';
import chatReducer from './_slice/chatReducer';
import invoiceReducer from './_slice/invoiceReducer'


const rootReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  contract: contractReducer,
  notification: notificationReducer,
  commission: commissionReducer,
  chat: chatReducer,
  invoice: invoiceReducer,
});
export default rootReducer;